import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { SharedModule } from '../../shared/shared.module';
import { StockDashboardModule } from '../stock/dashboard/dashboard.module';
import { TimeModule } from '../time/time.module';
import { WeatherModule } from '../weather/weather.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MaterialModule,
    SharedModule,
    StockDashboardModule,
    TimeModule,
    WeatherModule,
  ],
})
export class DashboardModule {}
